window.theme = window.theme || {};

class quickview extends HTMLElement {
  constructor() {
    super();
    $(".ap-quickview-popup .close-popup").click(function () {
      $(".ap-quickview-popup").removeClass("show");
      $(".ap-quickview-popup").hide();
    });
    this.addEventListener("click", (event) => {
      this.show(this);
    });
  }
  show(evt) {
    var url = "/products/" + this.getAttribute("data-handle");
    var _datahandle = this.getAttribute("data-handle");
    $.ajax({
      type: "GET",
      url: url + ".js",
      dataType: "json",
      beforeSend: function () {
        $(".qv-product-variants").html("");
        var ap_load_popup = new bootstrap.Modal(document.getElementById("ap-quickview-popup"), {
          keyboard: true,
        });
        $("#ap-quickview-popup .js-btn-wishlist").removeClass("active");
        $("#ap-quickview-popup .js-btn-compare").removeClass("active");
        $(".qv-quantity .quantity__input").val(1);
        ap_load_popup.show();
      },
      complete: function (data) {
        var product = JSON.parse(data["responseText"]);
        $("#ap-quickview-popup .product__title").html(product.title);
        $("#ap-quickview-popup .product__description").html(product.description);
        $("#qv-product-images").html("");
        $("#qv-product-images").attr("class", "");
        for (var i = 0; i < product.media.length; i++) {
          if (product.media[i]["media_type"] == "image") {
            $("#qv-product-images").append(
              '<div><img src="' +
                product.media[i]["src"] +
                '" alt="' +
                product["title"] +
                '"></div>'
            );
          }
        }
        if (product.variants.length) {
          $("#ap-quickview-popup .variant-id").val(product.variants[0]["id"]);
          $(".qv-product-price").html(
            Shopify.formatMoney(product.variants[0]["price"], theme.moneyFormat)
          );
          $(".qv-product-variants").html(
            '<p class="option-label">' + product.variants[0]["title"].replace("/", "|") + "</p>"
          );

          if (product.variants[0]["available"] == true) {
            $("#product-form-quickview .product-form__submit").removeAttr("disabled");
            $("#product-form-quickview .product-form__submit").html(
              $("#product-form-quickview .product-form__submit").data("addcartlabel")
            );
          } else {
            $("#product-form-quickview .product-form__submit").attr("disabled", "disabled");
            $("#product-form-quickview .product-form__submit").html(
              $("#product-form-quickview .product-form__submit").data("outofstock")
            );
          }

          $(".qv-product-variants .variants-item")
            .find("input")
            .each(function () {
              $(this).attr("id", $(this).attr("id") + "_");
            });
          $(".qv-product-variants .variants-item")
            .find("label")
            .each(function () {
              $(this).attr("for", $(this).attr("for") + "_");
            });
        }

        if ($(".qv-product-options").length) {
          $(".qv-product-options").html("");
          for (var i = 0; i < product.options.length; i++) {
            var str = "<div>";
            str += "<label>" + product.options[i]["name"] + "</label>";
            str += '<select class="qv-product-op-' + i + '">';
            for (var j = 0; j < product.options[i]["values"].length; j++) {
              str +=
                '<option value="' +
                product.options[i]["values"][j] +
                '">' +
                product.options[i]["values"][j] +
                "</option>";
            }
            str += "</select>";
            str += "</div>";
            $(".qv-product-options").append(str);
          }
        }

        $(".qv-product-tags").html("");
        for (var i = 0; i < product.tags.length; i++) {
          if (i == 0) {
            $(".qv-product-tags").append("<span>Tags:</span>");
          }
          if (product.tags.length > 1 && i > 0) {
            $(".qv-product-tags").append(", ");
          }
          $(".qv-product-tags").append(
            '<a href="/collections/all/' +
              product.tags[i] +
              '" class="link-product-tag"><strong>' +
              product.tags[i] +
              "</strong></a>"
          );
        }
        $("#ap-quickview-popup .js-btn-wishlist").attr("data-handle", _datahandle);
        $("#ap-quickview-popup .js-btn-compare").attr("data-handle", _datahandle);
        if ($.cookie("wishlist")) {
          var wishlist = $.cookie("wishlist").split(",");
          if (wishlist.indexOf(_datahandle) >= 0) {
            $("#ap-quickview-popup .js-btn-wishlist").addClass("active");
          }
        }
        if ($.cookie("compare")) {
          var compare = $.cookie("compare").split(",");
          if (compare.indexOf(_datahandle) >= 0) {
            $("#ap-quickview-popup .js-btn-compare").addClass("active");
          }
        }

        $("#ap-quickview-popup .view-product-quickview").find("a").attr("href", url);

        $("#qv-product-images").slick();
        $(".qv-product-options")
          .find("select")
          .change(function () {
            var arr_options = [];
            $(".qv-product-options")
              .find("select")
              .each(function () {
                arr_options.push($(this).val());
              });

            var title_variant = arr_options.join(" / ");
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i]["title"] == title_variant) {
                $("#product-form-quickview .variant-id").val(product.variants[i]["id"]);
                $(".qv-product-price").html(
                  Shopify.formatMoney(product.variants[i]["price"], theme.moneyFormat)
                );
                $(".qv-product-variants").html('<p class="option-label">' + title_variant + "</p>");
                if (product.variants[i]["available"] == true) {
                  $("#product-form-quickview .product-form__submit").removeAttr("disabled");
                  $("#product-form-quickview .product-form__submit").html(
                    $("#product-form-quickview .product-form__submit").data("addcartlabel")
                  );
                } else {
                  $("#product-form-quickview .product-form__submit").attr("disabled", "disabled");
                  $("#product-form-quickview .product-form__submit").html(
                    $("#product-form-quickview .product-form__submit").data("outofstock")
                  );
                }
              }
            }
          });

        // updateCurrencies();
        // document.querySelector('product-quickview').init();
      },
      error: function (xhr, text) {
        alert($.parseJSON(xhr.responseText).description);
      },
    });
  }

  init() {}
}
customElements.define("product-quickview", quickview);

class wishlist extends HTMLElement {
  constructor() {
    super();
    this.actiWishlist();
    this.addEventListener("click", (event) => {
      this.updateWishlist(this);
    });
  }

  updateWishlist(evt) {
    if (typeof $.cookie("wishlist") != "undefined" && $.cookie("wishlist")) {
      var wishlist = $.cookie("wishlist").split(",");
    } else {
      var wishlist = [];
    }

    if (wishlist.indexOf(this.getAttribute("data-handle")) >= 0) {
      wishlist.splice(wishlist.indexOf(this.getAttribute("data-handle")), 1);
      this.classList.remove("active");
    } else {
      wishlist.push(this.getAttribute("data-handle"));
      this.classList.add("active");
    }
    $(".num-wishlisted").html(wishlist.length + " Item(s)");
    $(".js-wishlist-count").html(wishlist.length + " Item(s)");

    $.cookie("wishlist", wishlist.join(","), { expires: 60, path: "/" });
  }

  actiWishlist(evt) {
    if (typeof $.cookie("wishlist") != "undefined" && $.cookie("wishlist")) {
      var wishlist = $.cookie("wishlist").split(",");
    } else {
      var wishlist = [];
    }

    $(".num-wishlisted").html(wishlist.length + " Item(s)");
    $(".js-wishlist-count").html(wishlist.length + " Item(s)");

    if (wishlist.indexOf(this.getAttribute("data-handle")) >= 0) {
      this.classList.add("active");
    }
  }
}
customElements.define("product-wishlist", wishlist);

class wishlistpage extends HTMLElement {
  constructor() {
    super();
    this.displayPage();
  }

  displayPage(evt) {
    if (typeof $.cookie("wishlist") != "undefined") {
      var wishlist = $.cookie("wishlist").split(",");
      if (wishlist.length) {
        document.querySelector("product-wishlistpage").addProductItem(wishlist, 0);
      }
    }
  }

  addProductItem(wishlist = [], i = 0) {
    if (i >= wishlist.length) {
      $(".js-btn-remove-wishlist").click(function () {
        if (typeof $.cookie("wishlist") != "undefined" && $.cookie("wishlist")) {
          var wishlist = $.cookie("wishlist").split(",");
          if (wishlist.indexOf($(this).data("handle")) >= 0) {
            wishlist.splice(wishlist.indexOf($(this).data("handle")), 1);
          }

          $(".num-wishlisted").html(wishlist.length + " Item(s)");
          $(".js-wishlist-count").html(wishlist.length + " Item(s)");

          $.cookie("wishlist", wishlist.join(","), { expires: 60, path: "/" });
          $(this).closest(".grid__item").remove();
        } else {
          $(".num-wishlisted").html(0 + " Item(s)");
          $(".js-wishlist-count").html(0 + " Item(s)");
        }
      });
      $(".grid__item").show();
      $(".wishlist-template").remove();
      updateCurrencies();
    } else {
      var template = $(".wishlist-template").clone(true);
      $.getJSON("/products/" + wishlist[i] + ".js", function (result) {
        var regular_price = Shopify.formatMoney(result.price, theme.moneyFormat);
        template.find("span.visually-hidden").html(result.title);
        template.find("a").attr("href", result.url);
        template.find("img").attr("srcset", result.featured_image);
        template.find("img").attr("src", result.featured_image);
        template.find(".variants-product-item").attr("data-handle", result.handle);
        template.find(".js-btn-quickview").attr("data-handle", result.handle);
        template.find(".js-btn-wishlist").attr("data-handle", result.handle);
        template.find(".js-btn-compare").attr("data-handle", result.handle);
        template.find(".product-id").val(result.variants[0].id);
        template.find(".card-information__text").html(result.title);
        template.find(".js-btn-wishlist").remove();
        template.find(".price__regular").html(regular_price);
        template.find(".price__sale").remove();

        template.append(
          '<button class="js-btn-remove-wishlist" data-handle="' +
            result.handle +
            '">Remove item</button>'
        );
        $(".js-wishlist-content ul").append(template);
        i++;
        document.querySelector("product-wishlistpage").addProductItem(wishlist, i);
      });

      template.removeClass("wishlist-template");
    }
  }
}
customElements.define("product-wishlistpage", wishlistpage);

class compare extends HTMLElement {
  constructor() {
    super();
    this.activeCompare();
    this.addEventListener("click", (event) => {
      this.updateCompare(this);
    });
    this.displayPage();
  }

  displayPage(evt) {
    if (typeof $.cookie("compare") != "undefined") {
      var compare = $.cookie("compare").split("|");
      if (compare.length) {
        $(".js-compare-count").html(compare.length);
      }

      if ($.cookie("compare")) {
        $(".js-compare-count").html(compare.length);
        console.log(compare.length);
      } else {
        $(".js-compare-count").html(0);
      }
    }
  }

  updateCompare(evt) {
    if (typeof $.cookie("compare") != "undefined" && $.cookie("compare")) {
      var compare = $.cookie("compare").split("|");
    } else {
      var compare = [];
    }

    if (compare.indexOf(this.getAttribute("data-handle")) >= 0) {
      compare.splice(compare.indexOf(this.getAttribute("data-handle")), 1);
      this.classList.remove("active");
    } else {
      compare.push(this.getAttribute("data-handle"));
      this.classList.add("active");
    }
    if (typeof $.cookie("compare") != "undefined" && $.cookie("compare") != "") {
      $(".js-compare-count").html(compare.length);
    } else {
      $(".js-compare-count").html(0);
    }

    $.cookie("compare", compare.join("|"), { expires: 60, path: "/" });
  }

  activeCompare(evt) {
    if (typeof $.cookie("compare") != "undefined" && $.cookie("compare")) {
      var compare = $.cookie("compare").split(",");
    } else {
      var compare = [];
    }
    $(".js-compare-count").html(compare.length);
    if (compare.indexOf(this.getAttribute("data-handle")) >= 0) {
      this.classList.add("active");
      //  this.querySelector('.name-btn-product').innerHTML(this.querySelector('.name-btn-product').getAttribute('data-remove'));
    }
  }
}
customElements.define("product-compare", compare);

class comparepage extends HTMLElement {
  constructor() {
    super();
    this.displayPage();
  }

  displayPage(evt) {
    if (typeof $.cookie("compare") != "undefined") {
      var compare = $.cookie("compare").split("|");
      if (compare.length) {
        document.querySelector("product-comparepage").addProductItem(compare, 0);
      }

      if ($.cookie("compare")) {
        $(".js-compare-count").html(compare.length);
      } else {
        $(".js-compare-count").html(0);
      }
    } 
  }

  addProductItem(compare = [], i = 0) {
    if (i >= compare.length) {
      $(".js-btn-remove-compare").click(function () {
        if (typeof $.cookie("compare") != "undefined" && $.cookie("compare") != "") {
          var compare = $.cookie("compare").split("|");
          if (compare.indexOf($(this).data("handle")) >= 0) {
            compare.splice(compare.indexOf($(this).data("handle")), 1);
          }

          if (typeof $.cookie("compare") != "undefined" && $.cookie("compare") != "") {
            $(".js-compare-count").html(compare.length);
          } else {
            $(".js-compare-count").html(0);
          }

          $.cookie("compare", compare.join("|"), { expires: 60, path: "/" });
          $(this).closest("tr").remove();
        }
      });
      $(".compare-template").remove();
      updateCurrencies();
    } else {
      var template = $(".compare-template").clone(true);
      template.removeClass("compare-template");
      $.getJSON("/products/" + compare[i] + ".js", function (result) {
        var regular_price = Shopify.formatMoney(result.price, theme.moneyFormat);
        template.find(".product-title").html(result.title);
        template.find(".full-unstyled-link").attr("href", result.url);
        template.find(".product-img").attr("src", result.featured_image);

        var variant = "";
        for (var j = 0; j < result.options.length; j++) {
          variant +=
            "<div><span>" +
            result.options[j].name +
            ": </span> " +
            result.options[j].values.join(", ") +
            "</div>";
        }
        template.find(".product-variants").html(variant);

        template.find(".product-price").html(regular_price);
        template.find(".product-type").html(result.type);
        template.find(".product-vendor").html(result.vendor);
        template.find(".js-btn-remove-compare").attr("data-handle", result.handle);
        template.show();
        $(".js-compare-content tbody").append(template);
        i++;
        document.querySelector("product-comparepage").addProductItem(compare, i);
      });
    }
  }
}
customElements.define("product-comparepage", comparepage);

class freeshipping extends HTMLElement {
  constructor() {
    super();
    this.update();
  }

  update(total_price) {
    var bar = 0;
    var free_cost = $(".js-free-shipping").data("cost");
    var cart_total = $(".js-free-shipping").data("value") / 100;
    if (total_price) {
      cart_total = total_price / 100;
    }
    bar = Math.round((cart_total / free_cost) * 100);
    if (parseFloat(bar) >= 100) {
      $(".js-free-shipping-text").html($(".js-free-shipping-text").data("free"));
      $(".js-free-shipping .progress-bar").addClass("free-progress-bar-100");
    } else {
      $(".js-free-shipping .progress-bar").removeClass("free-progress-bar-100");
      var current_pie = new Intl.NumberFormat(Shopify.locale, {
        style: "currency",
        currency: Shopify.currency.active,
      }).format(free_cost - cart_total);
      $(".js-free-shipping-text").html(
        $(".js-free-shipping-text").data("spend").replace("%%", current_pie)
      );
    }
    $(".js-free-shipping .progress-bar").css("width", bar + "%");
  }
}
customElements.define("cart-freeshipping", freeshipping);

$(document).ready(function () {
  $(".qv-quantity .quantity-minus").unbind();
  $(".qv-quantity .quantity-minus").click(function () {
    var qty = parseInt($(".qv-quantity .quantity__input").val());
    qty--;
    if (qty < 1) {
      qty = 1;
    }
    $(".qv-quantity .quantity__input").val(qty);
  });
  $(".qv-quantity .quantity-plus").unbind();
  $(".qv-quantity .quantity-plus").click(function () {
    var qty = parseInt($(".qv-quantity .quantity__input").val());
    qty++;
    $(".qv-quantity .quantity__input").val(qty);
  });
});

function updateCurrencies() {
  if (typeof $("#currencies").html() != "undefined") {
    if (Shopify.currency.active != $("#currencies a.selected").attr("data-currency")) {
      Currency.convertAll(
        Shopify.currency.active,
        $("#currencies a.selected").attr("data-currency")
      );
    }
  }
}

function initSlick(object) {
  if (!object.length) {
    return;
  }

  object.on("afterChange", function (event, slick, currentSlide, nextSlide) {
    $(".product-tab-carousel").removeClass("loadding");
    object.addClass("loaddinged");
  });

  object.not(".slick-initialized").slick({
    arrows: object.data("arrows"),
    dots: object.data("dots"),
    infinite: object.data("infinite"),
    autoplay: object.data("autoplay"),
    autoplayspeed: object.data("autoplayspeed"),
    speed: object.data("speed"),
    slidesToShow: object.data("slidestoshow"),
    slidestoscroll: object.data("slidestoscroll"),
    vertical: object.data("vertical"),
    verticalswiping: object.data("vertical"),
    pauseonhover: object.data("pauseonhover"),
    rows: object.data("rows"),
    centermode: object.data("centermode"),
    rtl: object.data("rtl"),
    draggable: true,
    asnavfor: object.data("asnavfor"),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: object.data("slidestoshow_tablet"),
          slidestoscroll: object.data("slidestoscroll_tablet"),
          dots: object.data("dots_tablet"),
          arrows: object.data("arrows_tablet"),
          rows: object.data("rows_tablet"),
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: object.data("slidestoshow_mobile"),
          slidestoscroll: object.data("slidestoscroll_mobile"),
          dots: object.data("dots_mobile"),
          arrows: object.data("arrows_mobile"),
          rows: object.data("rows_mobile"),
        },
      },
    ],
  });
}

theme.modalpopup = (function () {
  $(".btn-modal").click(function () {
    if ($(this).data("target")) {
      var target = $(this).data("target").replace("#", "");
      var ap_load_popup = new bootstrap.Modal(document.getElementById(target), { keyboard: true });
      ap_load_popup.show();
    }
  });

  function apLoadPopup() {
    $(".ap-auto-popup").each(function () {
      var _id = $(this).attr("id");
      if (!$(this).data("nextopen")) {
        setTimeout(function () {
          var ap_load_popup = new bootstrap.Modal(document.getElementById(_id), { keyboard: true });
          ap_load_popup.show();
        }, $(_id).data("delay") * 1000);
      } else {
        if ($.cookie(_id) != 1) {
          setTimeout(function () {
            var ap_load_popup = new bootstrap.Modal(document.getElementById(_id), {
              keyboard: true,
            });
            ap_load_popup.show();
          }, $(_id).data("delay") * 1000);
          $.cookie(_id, "1", { expires: 1, path: "/" });
        }
      }
    });
  }

  $(document).ready(function () {
    apLoadPopup();
  });
})();

theme.cookie_policy = (function () {
  setTimeout(function () {
    if (!$(this).data("nextopen")) {
      $(".js-cookie-policy").show();
    } else {
      if ($.cookie("cookie_law") != 1) {
        $(".js-cookie-policy").show();
        $.cookie("cookie_law", 1, { expires: 60, path: "/" });
      }
    }
  }, $(".js-cookie-policy").data("delay") * 1000);

  $(".js-cookie-policy .js-btn-ok").click(function () {
    $(".js-cookie-policy").remove();
  });
})();

theme.ajaxSearch = (function () {
  var numberdisplay = $(".search-results").data("numberdisplay");
  var typingTimer;
  var doneTypingInterval = 400;
  $("#search_ajax").keyup(function () {
    clearTimeout(typingTimer);
    if ($("#search_ajax").val().length > 1) {
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    }
  });

  function doneTyping() {
    var collection = "";
    var search_ajax = $("#search_ajax").val().toLowerCase();
    if (
      $(".collection-select-search select").length &&
      $(".collection-select-search select").val() != "all"
    ) {
      searchURL =
        "/collections/" + $(".collection-select-search select").val() + "/products.json?limit=250";
      collection = $(".collection-select-search select").val();
    } else {
      searchURL = "/collections/all/products.json?limit=250";
    }
    $.getJSON(searchURL, function (data) {
      $(".block-search .search-results").html("");
      if (data.products.length) {
        data = data.products;
        var numberdisplay = $(".block-search .search-results").data("numberdisplay");
        var count = 0;
        for (var i = 0; i < data.length; i++) {
          var title_product = data[i]["title"].toLowerCase();
          if (title_product.indexOf(search_ajax) != -1) {
            count++;
            if (count <= numberdisplay) {
              var ajax_product = '<li class="ajax-search-product">';
              ajax_product +=
                '<div class="ajax-search-product-col1"><a href="/products/' +
                data[i]["handle"] +
                '"><img src="' +
                data[i]["images"][0]["src"] +
                '" alt="' +
                data[i]["title"] +
                '"></a></div>';
              ajax_product += '<div class="ajax-search-product-col2">';
              ajax_product +=
                '<h3><a href="/products/' +
                data[i]["handle"] +
                '">' +
                data[i]["title"] +
                "</a></h3>";
              var data_price = data[i]["variants"][0]["price"] * 100;
              var price = Shopify.formatMoney(data_price, theme.moneyFormat);
              ajax_product +=
                '<div class="price" data-price="' + data_price + '">' + price + "</div>";
              ajax_product += "</div>";
              ajax_product += "</li>";
              console.log(ajax_product);
              $(".block-search .search-results").append(ajax_product);
            }
          }
        }

        if (numberdisplay < count) {
          $(".block-search .search-results").append(
            '<div class="view-all-search"><a href="search?collection=' +
              collection +
              "&options[prefix]=first&q=" +
              search_ajax +
              '">' +
              $(".block-search .search-results").data("viewall") +
              "</a></div>"
          );
        } else if (count == "") {
          $(".search-results").html(`<p class="text-center">No results</p>`);
        }

        $(document).click(function (event) {
          var target = event.target;
          if (!$(target).is(".search__input") && !$(target).parents().is(".search__input")) {
            $(".search-results").slideUp(300);
          }
        });
      } else {
      }
      updateCurrencies();
      $(".block-search .search-results").addClass("active").slideDown(300);
    });
  }
})();

theme.initslick = (function () {
  $(document).ready(function () {
    $(".block-carousel-slick").each(function () {
      initSlick($(this));
    });

    if ($(window).width() > 767) {
      $(".ap-slideshow").on("init", function (event, slick) {
        $(".ap-slideshow .slick-active .slide-show_content").addClass("active");
      });

      $(".ap-slideshow").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $(".ap-slideshow .slide-show_content").removeClass("active");
        $(".ap-slideshow .slide-show .slider-content").each(function () {
          if ($(this).data("slick-index") == nextSlide) {
            $(this).find(".slide-show_content").addClass("active");
          }
        });
      });
      initSlick($("#ap_slideshow"));
    } else {
      setTimeout(function () {
        initSlick($("#ap_slideshow"));
        $(".ap-slideshow").on("init", function (event, slick) {});
      }, $(".slide-show").data("delay") * 1000);
    }
  });
})();

theme.instafeed = (function () {
  var instafeed_stt = true;
  var productrecent_stt = true;
  var productsuggest_stt = true;
  var loadpopup_stt = true;
  $(window).scroll(function () {
    if ($("#instafeed").length && document.documentElement.scrollTop > 400) {
      if (instafeed_stt) {
        instafeed_stt = false;
        leo_create_instafeed();
      }
    }
  });

  function leo_create_instafeed() {
    if (
      typeof $("#instafeed").data("token") != "undefined" &&
      !$("#instafeed").hasClass("slick-initialized")
    ) {
      var limit = 20;
      if ($("#instafeed").data("limit")) {
        limit = $("#instafeed").data("limit");
      }
      var width = $("#instafeed").data("col_destop");
      if ($(window).width() < 1024) {
        width = $("#instafeed").data("col_tablet");
      }
      if ($(window).width() < 768) {
        width = $("#instafeed").data("col_mobile");
      }

      var feed = new Instafeed({
        accessToken: $("#instafeed").data("token"),
        limit: limit,
        template:
          '<a class="leo-instagram-size" target="_blank" href="{{link}}" style="width:' +
          width +
          '%;padding:0;"><img title="{{caption}}" src="{{image}}"/></a>',
        transform: function (item) {
          var d = new Date(item.timestamp);
          item.date = [d.getDate(), d.getMonth(), d.getYear()].join("/");
          return item;
        },
        after: function (data) {
          initSlick($("#instafeed"));
        },
      });
      feed.run();
    }
  }
})();

theme.detailproduct = (function () {
  function showsizeguide() {
    $(".open-sizeguide").click(function () {
      $("#ap-default-popup .modal-body").html('<img src="' + $(this).data("image") + '">');
      var ap_load_popup = new bootstrap.Modal(document.getElementById("ap-default-popup"), {
        keyboard: true,
      });
      ap_load_popup.show();
    });
  }

  function init() {
    showsizeguide();
  }

  return init();
})();

theme.detailproduct;

var openPhotoSwipe = function (index) {
  var pswpElement = document.querySelectorAll(".pswp")[0];

  let items = [];
  $("#product-detail-full-image img").each(function () {
    if ($(this).parent().hasClass("slick-slide")) {
      if (!$(this).parent().hasClass("slick-cloned")) {
        items.push({
          src: $(this).data("zoom-image"),
          w: $(this).data("width"),
          h: $(this).data("height"),
        });
      }
    } else {
      items.push({
        src: $(this).data("zoom-image"),
        w: $(this).data("width"),
        h: $(this).data("height"),
      });
    }
  });
  if (!index && $("#product-detail-full-image").hasClass("slick-initialized")) {
    index = $("#product-detail-full-image .slick-active").data("slick-index");
  }

  if (items.length < 2) {
    var arrows = false;
  } else {
    var arrows = true;
  }

  var options = {
    index: index,
    arrowEl: arrows,
    captionEl: false,
    closeOnScroll: false,
    counterEl: false,
    history: false,
    fullscreenEl: false,
    preloaderEl: false,
    shareEl: false,
    tapToClose: false,
  };

  var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

$("a.zoom_btn").click(function () {
  openPhotoSwipe();
  return false;
});

if (Shopify.designMode) {
  document.addEventListener(
    "shopify:section:load",
    (event) => {
      $(".block-carousel-slick").each(function () {
        initSlick($(this));
      });
      initSlick($("#ap_slideshow"));
    },
    true
  );
  document.addEventListener(
    "shopify:block:select",
    (event) => {
      var slide = $(".block-" + event.detail.blockId);
      var slideIndex = slide.data("slick-index");
      slide.closest(".block-carousel").slick("slickGoTo", slideIndex).slick("slickPause");
    },
    true
  );
}

$(document).ready(function () {
  addGroupProductCart();
  actionMenuMobile();

  $(".show_login").click(function () {
    if ($(".mini-acount").is(":visible")) {
      $(".mini-acount").slideUp("slow");
    } else {
      $(".mini-acount").slideDown("slow");
    }
  });

  $(".nav-pills li a").click(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $(this).tab("show");
  });

  $(".product-tab-link").click(function () {
    $(this).closest(".product-tab").find(".product-tab-link").removeClass("active");
    $(this).addClass("active");
    $(this).closest(".product-tab").find(".product-tab-carousel").hide();
    var source = $(this).data("controls");
    $(source).addClass("loadding");

    $(source).show();
    $(source).find(".block-carousel-slick")[0].slick.slickGoTo(1);
    // $(source).find(".block-carousel-slick").on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //   console.log('thanhvn');
    //   $(".product-tab-carousel").removeClass('loadding');
    // });
    // setTimeout(function() {
    //   $(".product-tab-carousel").removeClass('loadding');
    // }, 500);
  });

  updateCurrencies();
  theme.updatePriceFilter();
  $(".product-media-item .product__media-icon").show();

  if ($.cookie("wishlist")) {
    var wishlist = $.cookie("wishlist").split(",");
    $(".num-wishlisted").html(wishlist.length + " Item(s)");
    $(".js-wishlist-count").html(wishlist.length + " Item(s)");
  } else {
    $(".num-wishlisted").html(0 + " Item(s)");
    $(".js-wishlist-count").html(0 + " Item(s)");
  }
  // faqQuestion();
  // megamenuDisplay();
});

function addGroupProductCart() {
  $(".add-group-cart").click(function () {
    var id_products = [];
    $(".group_products input.group_product-item").each(function () {
      if ($(this).is(":checked")) {
        //$(this).parent().find('.product-form__submit').trigger('click');
        id_products.push($(this).val());
      }
    });
    $(".group-cart-products").addClass("loadding");
    addGroupProductCartItem(id_products, 0);
  });
}

function addGroupProductCartItem(products, i = 0) {
  if (i >= products.length) {
    $(".cart-notification__header h2").html("Item added to your cart");
    $("#cart-notification-product").html("");
    $(".group-cart-products").removeClass("loadding");
  } else {
    $.ajax({
      type: "POST",
      url: "/cart/add",
      data: {
        form_type: "product",
        id: products[i],
        quantity: 1,
        sections: ["cart-notification-product", "cart-notification-button", "cart-icon-bubble"],
        sections_url: "/products/5-pocket-jean",
        utf8: "✓",
      },
      dataType: "json",
      success: function (lineItem) {
        $("#cart-notification-product").html("");
        $("#cart-notification-product").html(
          $(lineItem["sections"]["cart-notification-product"]).find("div").html()
        );
        $("#cart-notification-button").html(
          $(lineItem["sections"]["cart-notification-button"]).html()
        );
        $("#cart-notification").addClass("active");
        $("#cart-icon-bubble").html(lineItem["sections"]["cart-icon-bubble"]);
        document.querySelector("mini-cart").update();
        i++;
        addGroupProductCartItem(products, i);
      },
      error: function (XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
        $(".group-cart-products").removeClass("loadding");
      },
    });
  }
}

function actionMenuMobile() {
  $(".site-header__icon-menu").click(function () {
    if ($("#section-header .nav-mega").hasClass("active")) {
      $("#section-header .nav-mega").removeClass("active");
      $("body").removeClass("has-menu-mobile");
    } else {
      $("#section-header .nav-mega").addClass("active");
      $("body").addClass("has-menu-mobile");
    }
  });

  $(".vertical-menu .icon-vertical-menu .vertical-bars").click(function () {
    if ($(".vertical-menu .nav-mega").hasClass("active")) {
      $(".vertical-menu .nav-mega").removeClass("active");
      $("body").removeClass("has-menu-vertical");
    } else {
      $(".vertical-menu .nav-mega").addClass("active");
      $("body").addClass("has-menu-vertical");
    }
  });

  $(".menu-close .button-close").click(function () {
    $(".nav-mega").removeClass("active");
    $("body").removeClass("has-menu-mobile");
    $("body").removeClass("has-menu-vertical");
  });

  $(".drawer__nav-toggle--open").click(function () {
    if ($(this).parent().hasClass("site-nav__item")) {
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(this).find("i").addClass("fa-angle-down");
        $(this).find("i").removeClass("fa-angle-up");
      } else {
        $(this).parent().addClass("active");
        $(this).find("i").removeClass("fa-angle-down");
        $(this).find("i").addClass("fa-angle-up");
      }
    } else {
      if ($(this).closest(".menu-link").hasClass("active")) {
        $(this).closest(".menu-link").removeClass("active");
        $(this).find("i").addClass("fa-angle-down");
        $(this).find("i").removeClass("fa-angle-up");
      } else {
        $(this).closest(".menu-link").addClass("active");
        $(this).find("i").removeClass("fa-angle-down");
        $(this).find("i").addClass("fa-angle-up");
      }
    }
  });

  $(".vertical-bkg").click(function () {
    $(".nav-mega").removeClass("active");
    $("body").removeClass("has-menu-mobile");
    $("body").removeClass("has-menu-vertical");
  });

  $(".drawer__ver-toggle--open").click(function () {
    if ($(this).parent().hasClass("site-nav__item")) {
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(this).find("i").addClass("fa-angle-down");
        $(this).find("i").removeClass("fa-angle-up");
      } else {
        $(this).parent().addClass("active");
        $(this).find("i").removeClass("fa-angle-down");
        $(this).find("i").addClass("fa-angle-up");
      }
    } else {
      if ($(this).closest(".menu-link").hasClass("active")) {
        $(this).closest(".menu-link").removeClass("active");
        $(this).find("i").addClass("fa-angle-down");
        $(this).find("i").removeClass("fa-angle-up");
      } else {
        $(this).closest(".menu-link").addClass("active");
        $(this).find("i").removeClass("fa-angle-down");
        $(this).find("i").addClass("fa-angle-up");
      }
    }
  });

  $(".title-footer").click(function () {
    if ($(this).parent().hasClass("menu-footer")) {
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(this).find("i").addClass("fa-angle-down");
        $(this).find("i").removeClass("fa-angle-up");
      } else {
        $(this).parent().addClass("active");
        $(this).find("i").removeClass("fa-angle-down");
        $(this).find("i").addClass("fa-angle-up");
      }
    }
  });

  $(".sticky-cart-close").click(function () {
    $(".sticky-cart-view").remove();
  });
}

// Currencies
Currency.format = "money_format";
var shopCurrency = Shopify.currency.active;
var cookieCurrency = Currency.cookie.read();

$("span.money span.money").each(function () {
  $(this).parent("span.money").removeClass("money");
});
$("span.money").each(function () {
  $(this).attr("data-currency-" + Shopify.currency.active, $(this).html());
  $(this).removeAttr("ls-currency-usd");
  $(this).removeAttr("ls-currency");
});
var buttons = $("#currencies a"),
  currentCurrencies = $(".pre-currencies");
if (cookieCurrency == null || cookieCurrency == shopCurrency) {
  Currency.currentCurrency = shopCurrency;
} else {
  Currency.currentCurrency = cookieCurrency;
  Currency.convertAll(shopCurrency, cookieCurrency);
  buttons.removeClass("selected");
  $("#currencies a[data-currency=" + cookieCurrency + "]").addClass("selected");
  var htmlCurrently = $("#currencies a[data-currency=" + cookieCurrency + "]").html();
  currentCurrencies.html(htmlCurrently);
}
buttons.click(function () {
  buttons.removeClass("selected");
  $(this).addClass("selected");
  var newCurrency = $(this).attr("data-currency");
  var htmlCurrently = $(this).html();
  currentCurrencies.html(htmlCurrently);
  Currency.convertAll(Currency.currentCurrency, newCurrency);
  $("#currencies").removeClass("active");
  $("#currencies").hide();
});
var original_selectCallback = window.selectCallback;
var selectCallback = function (variant, selector) {
  original_selectCallback(variant, selector);
  Currency.convertAll(shopCurrency, $("#currencies a.selected").attr("data-currency"));
};

$(".block_currencies .dropdown-toggle").click(function () {
  if ($("#currencies").hasClass("active")) {
    $("#currencies").removeClass("active");
    $("#currencies").hide();
  } else {
    $("#currencies").addClass("active");
    $("#currencies").show();
  }
});

function updateCurrencies() {
  if (typeof $("#currencies").html() != "undefined") {
    Currency.convertAll(shopCurrency, $("#currencies a.selected").attr("data-currency"));
  }
}

theme.updatePriceFilter = function () {
  function priceinputkeyup(obj, is_mobile) {
    var timeout = null;
    obj.keyup(function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (is_mobile) {
          if (typeof ($("#currencies a.selected").attr("data-currency") != "undefined")) {
            var p1 = parseInt(
              Currency.convert(
                $(".price-from-input-mobile").val(),
                $("#currencies a.selected").attr("data-currency"),
                shopCurrency
              )
            );
            var p2 = parseInt(
              Currency.convert(
                $(".price-to-input-mobile").val(),
                $("#currencies a.selected").attr("data-currency"),
                shopCurrency
              )
            );
          } else {
            var p1 = parseInt($(".price-from-input-mobile").val());
            var p2 = parseInt($(".price-to-input-mobile").val());
          }
        } else {
          if (typeof ($("#currencies a.selected").attr("data-currency") != "undefined")) {
            var p1 = parseInt(
              Currency.convert(
                $(".price-from-input").val(),
                $("#currencies a.selected").attr("data-currency"),
                shopCurrency
              )
            );
            var p2 = parseInt(
              Currency.convert(
                $(".price-to-input").val(),
                $("#currencies a.selected").attr("data-currency"),
                shopCurrency
              )
            );
          } else {
            var p1 = parseInt($(".price-from-input").val());
            var p2 = parseInt($(".price-to-input").val());
          }
        }

        $(".slider-range-content .price-from").html(
          Shopify.formatMoney(p1 * 100, theme.moneyFormat)
        );
        $("#Filter-Price-GTE").val(p1);
        $("#Filter-Price-LTE").val(p2);
        updateCurrencies();
        var form = $("<form id='CollectionFiltersForm'></form>");
        $("#CollectionFiltersForm input").each(function () {
          form.append($(this));
        });
        const formData = new FormData(form[0]);
        const searchParams = new URLSearchParams(formData).toString();
        document.querySelector("collection-filters-form").renderPage(searchParams, null, true);
      }, 1000);
    });
  }
  if (
    typeof $("#slider-range").html() != "undefined" &&
    typeof $("#slider-range-mobile").html() != "undefined"
  ) {
    if (typeof $("#currencies a.selected").attr("data-currency") != "undefined") {
      var max_price = parseInt(
        Currency.convert(
          parseInt($("#slider-range").data("max")),
          shopCurrency,
          $("#currencies a.selected").attr("data-currency")
        )
      );
      var min_price = parseInt(
        Currency.convert(0, shopCurrency, $("#currencies a.selected").attr("data-currency"))
      );
    } else {
      var max_price = parseInt($("#slider-range").data("max"));
      var min_price = 0;
    }

    var current_min_price = min_price;
    if ($("#Filter-Price-GTE").val()) {
      if (typeof $("#currencies a.selected").attr("data-currency") != "undefined") {
        current_min_price = parseInt(
          Currency.convert(
            parseInt($("#Filter-Price-GTE").val()),
            shopCurrency,
            $("#currencies a.selected").attr("data-currency")
          )
        );
      } else {
        current_min_price = parseInt($("#Filter-Price-GTE").val());
      }
    }
    var current_max_price = max_price;
    if ($("#Filter-Price-LTE").val()) {
      if (typeof $("#currencies a.selected").attr("data-currency") != "undefined") {
        current_max_price = parseInt(
          Currency.convert(
            parseInt($("#Filter-Price-LTE").val()),
            shopCurrency,
            $("#currencies a.selected").attr("data-currency")
          )
        );
      } else {
        current_max_price = parseInt($("#Filter-Price-LTE").val());
      }
    }
    priceinputkeyup($(".price-from-input"), 0);
    priceinputkeyup($(".price-to-input"), 0);

    $("#slider-range").attr("data-max", max_price);
    $("#slider-range").slider({
      range: true,
      min: min_price,
      max: max_price,
      values: [current_min_price, current_max_price],
      slide: function (event, ui) {
        if (typeof $("#currencies a.selected").attr("data-currency") != "undefined") {
          var p1 = parseInt(
            Currency.convert(
              ui.values[0],
              $("#currencies a.selected").attr("data-currency"),
              shopCurrency
            )
          );
          var p2 = parseInt(
            Currency.convert(
              ui.values[1],
              $("#currencies a.selected").attr("data-currency"),
              shopCurrency
            )
          );
        } else {
          var p1 = ui.values[0];
          var p2 = ui.values[1];
        }

        $("#Filter-Price-GTE").val(p1);
        $("#Filter-Price-LTE").val(p2);

        $(".slider-range-content .price-from").html(
          Shopify.formatMoney(p1 * 100, theme.moneyFormat)
        );
        $(".slider-range-content .price-to").html(Shopify.formatMoney(p2 * 100, theme.moneyFormat));

        updateCurrencies();
      },
      stop: function (event, ui) {
        var form = $("<form id='CollectionFiltersForm'></form>");
        $("#CollectionFiltersForm input").each(function () {
          form.append($(this));
        });

        if (typeof $("#currencies a.selected").attr("data-currency") != "undefined") {
          var p1 = parseInt(
            Currency.convert(
              ui.values[0],
              $("#currencies a.selected").attr("data-currency"),
              shopCurrency
            )
          );
          var p2 = parseInt(
            Currency.convert(
              ui.values[1],
              $("#currencies a.selected").attr("data-currency"),
              shopCurrency
            )
          );
        } else {
          var p1 = ui.values[0];
          var p2 = ui.values[1];
        }

        $(".slider-range-content .price-from").html(
          Shopify.formatMoney(p1 * 100, theme.moneyFormat)
        );
        $(".slider-range-content .price-to").html(Shopify.formatMoney(p2 * 100, theme.moneyFormat));
        updateCurrencies();
        const formData = new FormData(form[0]);
        const searchParams = new URLSearchParams(formData).toString();
        document.querySelector("collection-filters-form").renderPage(searchParams, null, true);
        if (!$("#slider-range").hasClass("ui-slider")) {
          theme.updatePriceFilter();
        }
      },
    });

    priceinputkeyup($(".price-from-input-mobile"), 1);
    priceinputkeyup($(".price-to-input-mobile"), 1);
    $("#slider-range-mobile").attr("data-max", max_price);
    $("#slider-range-mobile").slider({
      range: true,
      min: min_price,
      max: max_price,
      values: [current_min_price, current_max_price],
      slide: function (event, ui) {
        var p1 = parseInt(
          Currency.convert(
            ui.values[0],
            $("#currencies a.selected").attr("data-currency"),
            shopCurrency
          )
        );
        var p2 = parseInt(
          Currency.convert(
            ui.values[1],
            $("#currencies a.selected").attr("data-currency"),
            shopCurrency
          )
        );

        $("#Filter-Price-GTE").val(p1);
        $("#Filter-Price-LTE").val(p2);

        $(".slider-range-content .price-from").html(
          Shopify.formatMoney(p1 * 100, theme.moneyFormat)
        );
        $(".slider-range-content .price-to").html(Shopify.formatMoney(p2 * 100, theme.moneyFormat));
        updateCurrencies();
      },
      stop: function (event, ui) {
        var form = $("<form id='CollectionFiltersForm'></form>");
        $("#CollectionFiltersForm input").each(function () {
          form.append($(this));
        });

        var p1 = parseInt(
          Currency.convert(
            ui.values[0],
            $("#currencies a.selected").attr("data-currency"),
            shopCurrency
          )
        );
        var p2 = parseInt(
          Currency.convert(
            ui.values[1],
            $("#currencies a.selected").attr("data-currency"),
            shopCurrency
          )
        );

        $(".slider-range-content .price-from").html(
          Shopify.formatMoney(p1 * 100, theme.moneyFormat)
        );
        $(".slider-range-content .price-to").html(Shopify.formatMoney(p2 * 100, theme.moneyFormat));
        updateCurrencies();
        const formData = new FormData(form[0]);
        const searchParams = new URLSearchParams(formData).toString();
        document.querySelector("collection-filters-form").renderPage(searchParams, null, true);
        if (!$("#slider-range-mobile").hasClass("ui-slider")) {
          theme.updatePriceFilter();
        }
      },
    });
  }
};
// End

function allInit() {
  $(".apslick").each(function () {
    if (!$(this).hasClass("slick-initialized")) {
      initSlick($(this));
    }
  });

  if ($(window).width() > 767) {
    initSlick($(".slide-show .slide-slick"));
  } else {
    setTimeout(function () {
      initSlick($(".slide-show .slide-slick"));
    }, $(".slide-show").data("delay") * 1000);
  }

  collectionCoupon();
  productImageGallery();
}

$(document).ready(function () {
  allInit();
});

function collectionCoupon() {
  var clear = setInterval(function () {
    $("#jsCoupon").show();
    $("#jsCoupon").addClass("show");
  }, $("#jsCoupon").data("delay"));

  $(".js-btn-coupon").click(function () {
    var copyText = document.getElementById("coupon_code");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    $(".coupon-copied").show();
  });

  $(".modal-header .close").click(function () {
    clearInterval(clear);
  });
}
function productImageGallery() {
  if (typeof $("#product-full-image-zoom").attr("src") != "undefined") {
    initSlick($(".product-thumb-image-slick"));

    $("#product-full-image-zoom").elevateZoom({
      gallery: "product-gallery-image-zoom",
      zoomType: "inner",
      cursor: "crosshair",
    });

    $("#product-full-image-zoom").bind("click", function (e) {
      openPhotoSwipe();
      return false;
    });

    $(".product-thumb-image li img").click(function () {
      var slider = $("#product-gallery-image-zoom");
      slider[0].slick.slickGoTo(parseInt($(this).parent().data("slick-index")));
      if ($(this).hasClass("video-product")) {
      } else {
        $("img.product-full-image-zoom").attr("src", $(this).data("url"));
        $("img.product-full-image-zoom").attr("srcset", $(this).data("url"));
        $("img.product-full-image-zoom").attr("zoom-image", $(this).data("url"));
        $(".zoomWindowContainer .zoomWindow").css(
          "background-image",
          'url("' + $(this).data("url") + '")'
        );
      }
    });
  }
}
function displayCrossSell() {
  if (typeof $("#jsCrosssell").html() != "undefined") {
    $("#jsCrosssell").show();
    $("#jsCrosssell").addClass("show");
    $(".js-mini-cart-content").html($("#minicart .list-mimicart").clone(true));
    $(".js-mini-cart-right .js-cart-total").html($("#minicart .total_price").clone(true));
    $(".js-mini-cart-right .js-cart-count").html(
      $("#cart-icon-bubble .cart-count-bubble .visually-hidden").clone(true)
    );
  }
}

$(document).click(function (event) {
  var target = $(event.target);
  if (!target.closest(".utility_bar-currencies").length) {
    $(".block_currencies #currencies").hide();
  }
});

$(document).ready(function () {
  // CLOSE FILTER
  $(".icon-close").click(function () {
    $(".collection-filters").removeClass("active");
  });
  
  function tabEvent() {
    if (typeof $(".review-content").html() != "undefined") {
      $(".review-content").html($("#shopify-product-reviews").clone(true));
      $("#shopify-product-reviews").remove();
    }

    $("#tab-accordion a.card-link").click(function () {
      $("#tab-accordion .collapse").removeClass("show");
      $("#tab-accordion .card-header").removeClass("active-acc");
      $(this).parent().addClass("active-acc");
      $($(this).data("target")).addClass("show");
      return false;
    });

    $(".nav-tabs a").click(function () {
      $(this).closest("#nav-tab-info").find(".tab-content-value").removeClass("active show");
      $(this).parent().find("a").removeClass("active");
      $(this).parent().find("a").attr("aria-selected", false);
      $($(this).attr("href")).addClass("active show");
      $(this).addClass("active");
      $(this).attr("aria-selected", true);

      return false;
    });
  }
  tabEvent();

  function loadCountDown() {
    $(".js-countdown").each(function () {
      var time = $(this).data("time").replace("Z", "").split("T");
      var d = time[0].split("-");
      var m = "Jan";
      if (d[1] == 1) m = "Feb";
      if (d[1] == 2) m = "Mar";
      if (d[1] == 3) m = "Apr";
      if (d[1] == 4) m = "May";
      if (d[1] == 5) m = "Jun";
      if (d[1] == 6) m = "Jul";
      if (d[1] == 7) m = "Aug";
      if (d[1] == 8) m = "Sep";
      if (d[1] == 9) m = "Oct";
      if (d[1] == 10) m = "Nov";
      if (d[1] == 11) m = "Nov";
      if (d[1] == 12) m = "Dec";
      var d_t = m + " " + d[2] + ", " + d[0] + " " + time[1];

      var countDownDate = new Date(d_t).getTime();
      var el = $(this);
      var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        var html = '<div><span class="label-time">' + days + "</span>";
        if (days > 1) {
          html += '<span class="label">d</span>';
        } else {
          html += '<span class="label">d</span>';
        }
        html += "</div>";
        html +=
          '<span class="label-dots">:</span><div><span class="label-time">' +
          hours +
          '</span><span class="label">h</span></div>';
        html +=
          '<span class="label-dots">:</span><div><span class="label-time">' +
          minutes +
          '</span><span class="label">m</span></div>';
        html +=
          '<span class="label-dots">:</span><div><span class="label-time">' +
          seconds +
          '</span><span class="label">s</span></div>';
        el.html(html);
        if (distance < 0) {
          el.remove();
        }
      }, 1000);
      $(".off").click(function (e) {
        e.preventDefault();
        clearInterval(x);
      });
    });
  }
  loadCountDown();   

  function closePopup() {
    $(".modal-header .close").click(function () {
      $(this).closest(".modal").hide();
    });
  }
  closePopup();

  // Product video
  function productVideo() {
    let playButtonClass = ".js-play-button";
    $(document).on("click", playButtonClass, function () {
      let videoSelector = $(this).next(),
        videoObject = videoSelector.get(0);
      $(this).toggleClass("active");
      videoSelector.toggleClass("active");
      videoObject.paused ? videoObject.play() : videoObject.pause();
    });
  }
  productVideo();

  $(".close-search").click(function () {
    $(this).closest(".modal").removeClass("show");
    $(this).closest(".modal").hide();
  });
  function loaddingSlickProductTab() {
    $(".product-tab ul.nav.nav-pills button").click(function () {
      var el = $(this).closest(".section-block").find(".tab-content");
      el.height(el.height());
      el.addClass("active");
      var current_tab_content = $(this).data("bs-target");
      setTimeout(function () {
        el.removeClass("active");
        initSlick($(current_tab_content));
        $(current_tab_content).slick("slickGoTo", 0);
      }, 300);
    });
  }
  loaddingSlickProductTab();
  function tabEvent() {
    if (typeof $(".review-content").html() != "undefined") {
      $(".review-content").html($("#shopify-product-reviews").clone(true));
      $("#shopify-product-reviews").remove();
    }

    $("#tab-accordion a.card-link").click(function () {
      $("#tab-accordion .collapse").removeClass("show");
      $("#tab-accordion .card-header").removeClass("active-acc");
      $(this).parent().addClass("active-acc");
      $($(this).data("target")).addClass("show");
      return false;
    });

    $(".nav-tabs a").click(function () {
      $(this).closest("#nav-tab-info").find(".tab-content-value").removeClass("active show");
      $(this).parent().find("a").removeClass("active");
      $(this).parent().find("a").attr("aria-selected", false);
      $($(this).attr("href")).addClass("active show");
      $(this).addClass("active");
      $(this).attr("aria-selected", true);

      return false;
    });
  }
  tabEvent();
});
